//—— 故事頁那幾塊星書面板的「先發請求」——
//
//  作法與白夜的 baiye-teaser-cache 一樣，理由也一樣：
//  那幾段是 AI 生的、要幾秒，而送出的時機（故事頁掛載）比用到的時機
//  （捲到面板）早了二十秒 —— 中間隔著 jingyue-4 與 jingyue-5 兩支不能跳過的影片。
//  存 Promise 不存結果，故事頁先到就等一下，請求先到就立刻有值。
//
//  單發（single flight）：同一份問診資料只會真的打一次。
//  這不只是省錢 —— React 嚴格模式下 effect 會跑兩遍，不擋的話每個使用者
//  都會燒掉兩次 API 呼叫，而且兩份結果還不一樣，後到的會蓋掉先到的。
//
//  —— 掩護有多長（量過的）——
//  這支在故事頁掛載的那一刻發出，接著是兩支不能跳過的開場影片：
//    jingyue-4（她讀完這張盤）10.0 秒、jingyue-5（她開口）10.1 秒。
//  使用者還要捲到第一塊面板（第 11 塊 / 全頁 50 塊，約整頁的 22%）。
//  後端實測約 9 秒（見 engines/ziwei-jingyue/jingyue-teaser-engine 的時間預算），
//  所以這 20 秒還剩 11 秒餘裕 —— 網路差的裝置也接得住。

import generalService from "../../../service/general-service";

let pending = null;
let pendingKey = "";

//什麼算「同一份問診資料」。
//  只取會影響生成結果的欄位：排盤要生辰與性別，寫文案要他填的現況與煩惱。
//  信箱與姓名不算 —— 改了信箱不該重生一次（而且生成根本用不到）。
//
//  ⚠️ 紫微一定要有 birthTime（缺了定不出命宮），所以它在這裡是關鍵欄位，
//  不像白夜那邊可以是 "unknown"。
const keyOf = (intake) =>
  JSON.stringify([
    intake?.birthDate,
    intake?.birthTime,
    intake?.birthPlace?.label,
    intake?.gender,
    intake?.relation,
    intake?.orientation,
    intake?.relationship,
    intake?.career,
    intake?.concern,
  ]);

//故事頁一掛載就呼叫，不要 await。
//  回傳的 Promise 永遠 resolve（失敗時 resolve 成 null）——
//  沒有人 await 它的時候，一個 reject 會變成 unhandled rejection。
export const startTeaser = (intake) => {
  const key = keyOf(intake);
  if (pending && pendingKey === key) return pending;

  pendingKey = key;
  pending = generalService
    .jingyueTeaser(intake)
    .then(({ data }) => (data?.status ? data.data : null))
    .catch((e) => {
      console.warn("[鏡月] 命書生成失敗", e?.message);
      return null;
    });
  return pending;
};

//故事頁掛載時呼叫。沒有先發過就回 null（例如直接貼網址進故事頁）。
export const takeTeaser = () => pending;
